/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OWGameSEO
 */
export interface OWGameSEO {
    /**
     * Whether SEO is enabled for this game
     * @type {boolean}
     * @memberof OWGameSEO
     */
    enabled?: boolean;
    /**
     * SEO meta title
     * @type {string}
     * @memberof OWGameSEO
     */
    metaTitle?: string;
    /**
     * SEO meta description
     * @type {string}
     * @memberof OWGameSEO
     */
    metaDescription?: string;
    /**
     * SEO keywords
     * @type {Array<string>}
     * @memberof OWGameSEO
     */
    keywords?: Array<string>;
    /**
     * Open Graph title for social sharing
     * @type {string}
     * @memberof OWGameSEO
     */
    ogTitle?: string;
    /**
     * Open Graph description for social sharing
     * @type {string}
     * @memberof OWGameSEO
     */
    ogDescription?: string;
    /**
     * Open Graph image URL (should use CDN URL)
     * @type {string}
     * @memberof OWGameSEO
     */
    ogImage?: string;
    /**
     * Twitter card type (summary_large_image)
     * @type {string}
     * @memberof OWGameSEO
     */
    twitterCard?: string;
    /**
     * Twitter title for sharing
     * @type {string}
     * @memberof OWGameSEO
     */
    twitterTitle?: string;
    /**
     * Twitter description for sharing
     * @type {string}
     * @memberof OWGameSEO
     */
    twitterDescription?: string;
    /**
     * Twitter image URL (should use CDN URL)
     * @type {string}
     * @memberof OWGameSEO
     */
    twitterImage?: string;
}

/**
 * Check if a given object implements the OWGameSEO interface.
 */
export function instanceOfOWGameSEO(value: object): value is OWGameSEO {
    return true;
}

export function OWGameSEOFromJSON(json: any): OWGameSEO {
    return OWGameSEOFromJSONTyped(json, false);
}

export function OWGameSEOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWGameSEO {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'metaTitle': json['metaTitle'] == null ? undefined : json['metaTitle'],
        'metaDescription': json['metaDescription'] == null ? undefined : json['metaDescription'],
        'keywords': json['keywords'] == null ? undefined : json['keywords'],
        'ogTitle': json['ogTitle'] == null ? undefined : json['ogTitle'],
        'ogDescription': json['ogDescription'] == null ? undefined : json['ogDescription'],
        'ogImage': json['ogImage'] == null ? undefined : json['ogImage'],
        'twitterCard': json['twitterCard'] == null ? undefined : json['twitterCard'],
        'twitterTitle': json['twitterTitle'] == null ? undefined : json['twitterTitle'],
        'twitterDescription': json['twitterDescription'] == null ? undefined : json['twitterDescription'],
        'twitterImage': json['twitterImage'] == null ? undefined : json['twitterImage'],
    };
}

export function OWGameSEOToJSON(json: any): OWGameSEO {
    return OWGameSEOToJSONTyped(json, false);
}

export function OWGameSEOToJSONTyped(value?: OWGameSEO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
        'metaTitle': value['metaTitle'],
        'metaDescription': value['metaDescription'],
        'keywords': value['keywords'],
        'ogTitle': value['ogTitle'],
        'ogDescription': value['ogDescription'],
        'ogImage': value['ogImage'],
        'twitterCard': value['twitterCard'],
        'twitterTitle': value['twitterTitle'],
        'twitterDescription': value['twitterDescription'],
        'twitterImage': value['twitterImage'],
    };
}

